module.exports = __webpack_public_path__ + "assets/closeMobileModal-cdc8b2.svg";